import * as React from 'react';
import { cn } from '@/shared/lib/utils';
import { themed } from './themed';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, htmlFor, ...props }, ref) => (
    <label
      ref={ref}
      htmlFor={htmlFor}
      className={cn('mb-1 block text-sm font-medium', themed.text.secondary, className)}
      {...props}
    />
  ),
);
Label.displayName = 'Label';
